import { render, staticRenderFns } from "./ReturnListDetail.vue?vue&type=template&id=56163faf&scoped=true"
import script from "./ReturnListDetail.vue?vue&type=script&lang=js"
export * from "./ReturnListDetail.vue?vue&type=script&lang=js"
import style0 from "./ReturnListDetail.vue?vue&type=style&index=0&id=56163faf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56163faf",
  null
  
)

export default component.exports